// components
import GridPageAbstract from '../../GridPageAbstract';
import { UserOctagonBulkIcon } from '../../../icons-lib/bulkIcons';
import config from '../../../config';

export default class PartnerAccountsPage extends GridPageAbstract {
    constructor(props) {
        super(props);

        this.Name = 'partnerAccounts';
        this.Server = this.props.context.getState().server.partnerAccounts;

        this.headerStartIcon = UserOctagonBulkIcon;
        this.bannerImage = config?.bannerImages?.transactions || '';

        this.searchFields = [
            'partner.name',
            'name'
        ];

        this.hiddenColumns = config?.hiddenColumns?.partnerAccounts || [];

        this.Head = [
            {
                id: 'partnersId',
                label: 'partner',
                object: 'partner',
                alignRight: false,
                cell: 'Select',
                from: 'partners',
                display: 'name',
                filterCell: 'Context',
                filterBy: 'partners'
            },
            {
                id: 'coinId',
                label: 'coin',
                object: 'coin',
                alignRight: false,
                cell: 'Select',
                from: 'coins',
                display: 'name',
                filterCell: 'Context',
                filterBy: 'coins'
            },
            { id: 'name', label: 'name', alignRight: false, cell: 'Text' },
            {
                id: 'description',
                label: 'description',
                alignRight: false,
                cell: 'Text'
            },
            {
                id: 'dateCreated',
                label: 'dateCreated',
                alignRight: false,
                cell: 'Date',
                filterCell: 'Date',
                disableEditor: true
            },
            {
                id: 'dateModified',
                label: 'dateModified',
                alignRight: false,
                cell: 'Date',
                filterCell: 'Date',
                disableEditor: true
            }
        ].filter((column) => !this.hiddenColumns.includes(column.id));
    }
}
